<template>
  <transition name="fade">
    <div class="picture-popup"  v-show="show" @click="handleHidePopup()" >
      <div class="image-wrap" ref="swiperWrap">
        <div class="image-box">
          <div class="image-item" v-for="(item, index) in picList" :key="index">
            <img :src="item.url || item.imgPath" v-if="item.url || item.imgPath"/>
            <img :src="item" v-else />
          </div>
        </div>
        <div class="desc-info">
          <div class="title">{{picList.length ? (picList[(i ? i : index)].title ? picList[(i ? i : index)].title : picList[(i ? i : index)].imgName) : ''}}</div>
          <div class="pages"><i>{{(typeof i === 'number' ? i : index) + 1}}</i> / {{picList.length}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Swiper from '../../util/touch.js'
export default {
  name: 'pic-popup',
  props: {
    index: Number,
    picList: Array,
    isShow: Boolean
  },
  data () {
    return {
      show: this.isShow,
      i: this.index
    }
  },
  methods: {
    handleHidePopup () {
      this.show = false
      this.$emit('handleHidePopup', this.show)
      this.scroll = ''
    }
  },
  watch: {
    isShow (value) {
      let _this = this
      this.show = value
      this.$nextTick(() => {
        this.scroll = new Swiper(this.$refs.swiperWrap, {
          wrapper: '.image-box',
          slide: '.image-item',
          speed: 2000,
          autoPlay: false,
          initialSlide: _this.index,
          endFn: function (data) {
            _this.i = data
          }
        })
      })
    },
    index (value) {
      this.i = value
    }
  }
}
</script>
<style lang="scss">
  .fade-enter, .fade-leave-active, .fade-enter-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  .picture-popup{
    width: 100%;
    height: 100%;
    background: #000000;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    line-height: 100%;
    overflow: hidden;
    .desc-info{
      width: 100%;
      height: 0.3rem;
      display: flex;
      position: absolute;
      left: 0;
      bottom: 0.48rem;
      .title{
        flex: 1;
        padding-left: 0.3rem;
        line-height: 80%;
        color:white;
        font-size: 0.32rem;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .pages{
        width: 1rem;
        height: .3rem;
        text-align: right;
        margin-right: .3rem;
        color:white;
        line-height: 80%;
        font-size: .26rem;
        display: block;
        i{
          font-style:normal;
          font-size: .32rem;
        }
      }
    }
    .image-wrap{
      width:100%;
      height:100%;
      position: relative;
    }
    .image-box{
      width: 100%;
      height: 100%;
      display: flex;
      box-sizing: border-box;
    }
    .image-item{
      color: white;
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      flex-shrink: 0;
      z-index: 10;
      overflow: hidden;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/picturePopup/picture-popup.vue